<script lang="ts">
    import { t } from "@lernetz/svelte-translate";
    import { createEventDispatcher, onMount } from "svelte";

    export let formData;
    export let categories;

    const cycle2Order = ['Wetter', 'Sturm', 'Hagel', 'Blitzschlag', 'Wassergefahren', 'Murgang', 'Rutsch', 'Sturz', 'Lawine', 'Klima'];
    const cycle2OrderFr = ['Météo / Temps', 'Tempêtes', 'Grêle', 'Foudre', "Dangers liés à l'eau", 'Laves torrentielles', 'Glissements de terrain', 'Éboulements', 'Avalanche', 'Climat'];

    let filteredCategories = categories.filter(item => item.cycle === formData.cycle);

    if (formData.cycle === 'cycle2') {
        const order = formData.lang === 'fr' ? cycle2OrderFr : cycle2Order;
        filteredCategories = [
            ...order.map(name => filteredCategories.find((c: any) => c.name === name)).filter(Boolean),
            ...filteredCategories.filter((c: any) => !order.includes(c.name)),
        ];
    }

    const dispatch = createEventDispatcher();

    if (filteredCategories.length === 1) {
        formData.selectedCategories = [filteredCategories[0].id];
        onMount(() => dispatch('next'));
    }

    $: isValid = formData.selectedCategories.length > 0;

    function toggleCategory(id: number) {
        if (formData.selectedCategories.includes(id)) {
        formData.selectedCategories = formData.selectedCategories.filter(x => x !== id);
        } else {
        formData.selectedCategories = [...formData.selectedCategories, id];
        }
    }

    $: allSelected = filteredCategories.length > 0 && formData.selectedCategories.length === filteredCategories.length;

    function toggleAll() {
        if (allSelected) {
            formData.selectedCategories = [];
        } else {
            formData.selectedCategories = filteredCategories.map(c => c.id);
        }
    }

</script>

<div class="bg-white w-full max-w-580 p-24 md:p-48 rounded-3xl overflow-y-auto flex flex-col max-h-[calc(100dvh-6rem)] md:max-h-[calc(100dvh-3rem)]">
    <div class="text-28 font-bold text-center">
        {$t('Select topics')}
    </div>
    <div class="text-18 mt-32">
        {$t("Select one or more topics to test your pupils' knowledge.")}
    </div>
    <button on:click={toggleAll} class="text-blue-main text-16 font-bold mt-24 w-fit">
        {allSelected ? $t('deselect all') : $t('select all')}
    </button>
    <div class="flex flex-col gap-8 text-18 font-bold mt-8">
    {#each filteredCategories as category}<!-- {formData.cycle == 'cycle1' ? 'bg-yellow-light border-yellow-main' : 'bg-green-light border-green-main'} -->
    {@const isSelected = formData.selectedCategories.includes(category.id)}
    {@const isCycle1 = formData.cycle === 'cycle1'}

    <div
        class="border-2 rounded-lg px-14 py-10
        {isCycle1
            ? (isSelected
                ? 'bg-yellow-main text-white border-yellow-main'
                : 'bg-white text-yellow-main border-yellow-main')
            : (isSelected
                ? 'bg-green-main text-white border-green-main'
                : 'bg-white text-green-main border-green-main')
        }"
    >
        <label class="flex items-center gap-2">
            <input
                type="checkbox"
                checked={isSelected}
                on:change={() => toggleCategory(category.id)}
                class="mr-8 w-22 h-22"
            />
            {category.name}
        </label>
    </div>
    {/each}
    </div>
    <div class="flex justify-between items-center mt-24">
        <button on:click={() => dispatch('back')} class="border-blue-main border-2 text-blue-main px-24 py-10 rounded-md w-fit font-bold">{$t('back')}</button>
        <span class="text-18 font-bold text-grey-1">2/3</span>
        <button disabled={!isValid} on:click={() => dispatch('next')} class="{!isValid ? 'bg-blue-light' : 'bg-blue-main'} px-24 py-10 rounded-md text-white w-fit">{$t('next')}</button>
    </div>
</div>
